import { render } from "./AdminViewRequest.vue?vue&type=template&id=52437f2d"
import script from "./AdminViewRequest.vue?vue&type=script&lang=js"
export * from "./AdminViewRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__